const styles = {
  documentForm: {
    marginBottom: '20px',
  },
};

export default styles;
